<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0">Projets du client</h4>
      <b-button size="sm" variant="outline-primary" @click="refreshProjects">
        <feather-icon icon="RefreshCwIcon" size="14"/>
      </b-button>
    </div>
    <b-alert v-if="projects && projects.length === 0" show variant="info">
      Ce client n'a pas encore de projets associés.
    </b-alert>

    <b-overlay :show="loading" rounded="sm" spinner-variant="primary">
      <b-table
          ref="projectsList"
          :fields="tableFields"
          :per-page="perPage"
          :current-page="currentPage"
          :items="fetchClientSpecificProperty"
          :sort-by.sync="sortBy"
          :busy="loading"
          :show-empty="true"
          empty-text="Aucune entrée enregistrée"
          hover
          responsive
          striped
      >
        <!-- Colonnes personnalisées -->
        <template #cell(type)="data">
          <b-badge :variant="getTypeVariant(data.item.type)">
            {{data.item.type }}
          </b-badge>
        </template>

        <template #cell(budget)="data">
          {{ amountToCurrency(data.item.budget) }}
        </template>

        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
                :to="{ name: 'projects-view', params: { id: data.item.uid } }"
                class="btn-icon mr-1"
                size="sm" variant="flat-primary"
            >
              <feather-icon icon="EyeIcon" size="16"/>
            </b-button>
          </div>
        </template>
      </b-table>

      <b-pagination
          v-if="projects && projects.length > 0"
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="meta.total"
          align="center"
          class="mt-2"
      />
    </b-overlay>
  </div>
</template>

<script>
import {formatDate} from '@core/utils/filter'
import {BAlert, BBadge, BButton, BOverlay, BPagination, BTable} from "bootstrap-vue";
import {mapState} from "vuex";
import {amountToCurrency} from "@/utils/formatAmount";
import store from "@/store";

export default {
  name: 'ClientsViewClientProjectList',
  components: {BPagination, BButton, BBadge, BTable, BOverlay, BAlert},
  data() {
    return {
      tableFields: [
        {key: 'project_code', label: 'Code du projet', sortable: true},
        {key: 'type', label: 'Type', formatter: val => val.toUpperCase()},
        {key: 'created_at', label: 'Date', sortable: true, formatter: val => formatDate(val, 'DD/MM/YYYY')},
        {key: 'actions', label: 'Actions'}
      ],
      currentPage: 1,
      perPage: 5,
      sortBy: 'created_at',
      sortDesc: true,
      loading: false,
    }
  },
  computed: {
    clientId() {
      return this.$route.params.id
    },
    ...mapState('client', {
      projects: state => state.clientProjects,
      meta: state => state.clientProjectsMeta,
    })
  },
  methods: {
    amountToCurrency,
    refreshProjects() {
      this.$refs.projectsList.refresh();
    },
    getTypeVariant(type) {
      const variants = {
        'étude': 'success',
        'contrôle': 'warning',
        'étude et contrôle': 'info',
      }
      return variants[type] || 'secondary'
    },
    async fetchClientSpecificProperty(ctx, callback) {
      this.loading = true
      const params = {
        page: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      }
      try {
        store.dispatch('client/fetchClientProjects', {
          client: this.clientId,
          params
        }).then((response) => {
          callback(response)
        })
      } catch (error) {
        this.$toast({
          component: 'b-toast',
          props: {
            title: 'Erreur',
            variant: 'danger',
            content: "Erreur lors du chargement des projets"
          }
        })
      } finally {
        this.loading = false
      }
    },
  }
}
</script>